import React from "react";
import { Modal as PdModal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import UsersDealerForm from "~/components/Forms/UsersDealerForm";
import UsersForm from "~/components/Forms/UsersForm";
import useGetUsers from "~/components/Forms/UsersForm/hooks/useGetUsers";
import Button from "~/shared/ui/Fields/Button";
import Modal from "~/shared/ui/Fields/Modal";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { onScrollBottomSubdivision } from "~/hooks/selectSubdivisionValue";
import {
  useDeleteUserMutation,
  useRestoreUserMutation,
} from "~/schemas/generated/graphql";

const ModalsComponent = ({ refetchUserList, dataUserList }) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const { openModal, openChildModal, currentId } = useGetLocationData();
  const subdivisionsForSelect = onScrollBottomSubdivision();
  const {
    data: dataUser,
    isLoading: isLoadingUser,
    refetch: refetchUser,
  } = useGetUsers(currentId);
  const selectedUser = dataUserList?.items.find((i) => i.id == currentId);
  const modalRestore = openModal === "Restore";

  const [restoreUserMutation] = useRestoreUserMutation({
    variables: { id: String(currentId) },
    onCompleted() {
      refetchUserList();
    },
  });
  const [deleteUserMutation] = useDeleteUserMutation({
    variables: { id: String(currentId) },
    onCompleted() {
      refetchUserList();
    },
  });

  const handleCloseModal = () => {
    setData("openModal", "");
  };
  const handleCloseChildModal = () => {
    setData("openChildModal", "");
  };
  const deleteUser = () => {
    deleteUserMutation();
    handleCloseModal();
  };
  const restoreUser = () => {
    restoreUserMutation();
    handleCloseModal();
  };
  const openDCModal = () => {
    setData("openChildModal", "View");
  };

  return (
    <>
      <Modal
        isOpen={openModal === "Edit" && !!dataUser?.user}
        title={t("users.user_edit")}
        actionClose={handleCloseModal}
      >
        <UsersForm
          setCloseModal={handleCloseModal}
          subdivisionsForSelect={subdivisionsForSelect}
          usersRefetch={refetchUserList}
          user={selectedUser}
          dataUser={dataUser}
          isLoadingUser={isLoadingUser}
          refetchUser={refetchUser}
          setOpenDC={openDCModal}
        />
      </Modal>

      <PdModal
        open={openChildModal === "View"}
        title={t("users_dealer_form.edit_inactive")}
        onCancel={handleCloseChildModal}
        size="large"
        centered
        closable
        footer={null}
        okButton={{
          children: t("ui.finish_editing"),
          onClick: handleCloseChildModal,
        }}
        destroyOnClose
      >
        <UsersDealerForm user={selectedUser} usersRefetch={refetchUserList} />
      </PdModal>

      <Modal
        isOpen={openModal === "Sure" || openModal === "Restore"}
        title={!modalRestore ? t("users.user_del") : t("ui.restoreUser")}
        actionClose={handleCloseModal}
      >
        <Button txtBtn={t("ui.cancel")} empty onClick={handleCloseModal} />
        <Button
          txtBtn={modalRestore ? t("ui.restore") : t("ui.delete")}
          onClick={modalRestore ? restoreUser : deleteUser}
        />
      </Modal>
    </>
  );
};

export default ModalsComponent;
